module.exports = __webpack_public_path__ + "img/unlock-keyhole.c26b2f18.svg";